import React, { Component } from "react";
import "./RateButton.css";

interface Props {
  style: any;
  label: string;
  value: any;
  onclick: any;
}

export const RateButton = ({ style, label, value, onclick }: Props) => {
  return (
    <div className="RateButton" style={style} onClick={onclick}>
      <div className="RateButton-Label">{label}</div>
      <div className="RateButton-Value">{value}</div>
    </div>
  );
};
